import { del, EndPoints, get, patch, post } from '../';
export function list() {
    return get(EndPoints.groups, { all: 1 });
}
export function createGroup(request) {
    return post(EndPoints.groupsCreate, request);
}
export function updateGroup(request) {
    return patch(EndPoints.groupsUpdate, request);
}
export function deleteGroup(request) {
    return del("" + EndPoints.groupsDelete, request);
}
